/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'ep-migration-inapp-2131': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-2131/placements/in-app/screen-space-flags/render'
			),
	),
	'ep-migration-inapp-2270': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-2270/placements/in-app/screen-space-flags/render'
			),
	),
	'ep-migration-inapp-2271': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-2271/placements/in-app/screen-space-flags/render'
			),
	),
	'ep-migration-inapp-3280': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-3280/placements/in-app/screen-space-flags/render'
			),
	),
	'ep-migration-inapp-3282': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--ep-migration-inapp-3282/placements/in-app/screen-space-flags/render'
			),
	),
	'starburst-screen-space-flags-twc-welcome-modal': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--starburst-screen-space-flags-twc-welcome-modal/placements/in-app/screen-space-flags/render'
			),
	),
	'twc-xflow-modal': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--twc-xflow-modal/placements/in-app/screen-space-flags/render'
			),
	),
};
